export const GET_ALL_LE = "GET_ALL_LE";
export const CREATE_CLIENT = "CREATE_CLIENT";

export const getallLE = () => {
  return {
    type: GET_ALL_LE
  };
};

export const CreateClient = (data) => {
    return {
      type: CREATE_CLIENT,
      payload:data
    };
  };



